import api from '../../config/AxiosService';
import { AuthRegisterDto, AwsUserList } from '../../types/users';

export const getUserList = async (): Promise<AwsUserList> => {
  const response = await api.get(`/auth/list`);
  return response.data;
};

export const createUser = async (user: AuthRegisterDto) => {
  const response = await api.post(`/auth/register-user`, user, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

export const deleteUser = async (email: string) => {
  const response = await api.delete(`/auth/${email}`);
  return response.data;
};

export const addAdminRights = async (email: string) => {
  const response = await api.post(`/auth/add-admin-rights-to-user/${email}`);
  return response.data;
};

export const removeAdminRights = async (email: string) => {
  const response = await api.post(`/auth/remove-admin-rights-from-user/${email}`);
  return response.data;
};
